export default __webpack_public_path__ + "64df5c299bab129b228bf6dad75329d2.png";